<div [attr.data-qa]="qaTag"
     [class.modal-dialog-fixed-width]="shouldUseFixedDialogWidth"
     class="modal-dialog">
    @if (modalData.titleTranslationKey) {
        <h2 [attr.data-qa]="qaTag + '-title'"
            class="modal-dialog-title">{{ modalData.titleTranslationKey | translate: modalData.translateKeyParameters }}</h2>
    }
    <div [class]="messageCssClass">
        @if (modalData.descriptionTranslationKey) {
            <p [attr.data-qa]="qaTag + '-message'" [innerHTML]="modalData.descriptionTranslationKey | translate: modalData.translateKeyParameters"></p>
        }
        @if (modalData.inputs) {
            <div class="modal-dialog-vertical-flex">
                @for (field of modalData.inputs | keyvalue:indexOrderAsc; track i; let i = $index) {
                    @if (field.value.label) {
                        <label [for]="field.key">{{ field.value.label | translate: modalData.translateKeyParameters }}</label>
                    }
                    @if (field.value.asTextarea) {
                        <textarea [(ngModel)]="field.value.value"
                                  [attr.data-qa]="field.value.appTestTag"
                                  [class.no-label]="!field.value.label"
                                  [id]="field.key"
                                  [name]="field.key"
                                  [placeholder]="(field.value.placeholder || '') | translate: modalData.translateKeyParameters"
                                  autocomplete="off"
                                  type="text"></textarea>
                    } @else {
                        <input [(ngModel)]="field.value.value"
                               [attr.data-qa]="field.value.appTestTag"
                               [class.no-label]="!field.value.label"
                               [id]="field.key"
                               [name]="field.key"
                               [placeholder]="(field.value.placeholder || '') | translate: modalData.translateKeyParameters"
                               autocomplete="off"
                               type="text"/>
                    }
                }
            </div>
        }
    </div>
    <div class="modal-dialog-action-text-buttons">
        <app-button (clicked)="save()"
                    [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                    [buttonColor]="ButtonColorEnum.RED"
                    [buttonText]="modalData.saveBtnTranslationKey | translate : modalData.translateKeyParameters"
                    [qaTag]="qaTag + '-save-button'"/>
        @if (modalData.cancelBtnTranslationKey) {
            <app-button (clicked)="cancel()"
                        [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                        [buttonColor]="ButtonColorEnum.BLACK_WHITE"
                        [buttonText]="modalData.cancelBtnTranslationKey | translate : modalData.translateKeyParameters"
                        [qaTag]="qaTag + '-cancel-button'"/>
        }
    </div>
</div>
